export const CHAT_START_TAG = 'inbx_web_chat_start_chat';
export const LEAD_CAPTURE_TAG = 'inbx_web_chat_lead_captured';
export const SEND_MESSAGE_TAG = 'inbx_web_chat_clicked_send_message';
export const BOOK_APPOINTMENT_TAG = 'inbx_web_chat_clicked_appointment_time';
export const CHAT_BUTTON_TOGGLE_TAG = 'inbx_web_chat_clicked_fab_openclose_widget';
export const WIDGET_IMPRESSION_TAG = 'inbx_web_chat_widget_impression';
